import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { RouterLink } from 'src/components/router-link';
import { Seo } from 'src/components/seo';
import { usePageView } from 'src/hooks/use-page-view';
import { paths } from 'src/paths';
import { ArrowLeftIcon } from '@mui/x-date-pickers';
import { Avatar, Chip, SvgIcon } from '@mui/material';
import { CustomerEditForm } from './sub-forms/customer-edit-form';
import { useEffect, useState } from 'react';
import { getInitials } from 'src/utils/get-initials';
import { useLocation, useNavigate } from 'react-router';

const convertBase64 = (file: any, setbase64File: any) => {
  if (file) {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      const base64String = e.target.result;
      setbase64File(base64String?.split(',')[1]);
    };
    reader.readAsDataURL(file);
  }
};

const AddPatientForm = ({ action }: any) => {
  usePageView();
  const [file, setFile] = useState<any>(null);
  const [base64String, setbase64File] = useState('');

  const location = useLocation();
  const navigate = useNavigate();
  const [patientData, setPatientData] = useState<any>(null);
  useEffect(() => {
    setPatientData(location?.state?.patientData);
  }, []);

  useEffect(() => {
    if (file) {
      convertBase64(file, setbase64File);
    }
  }, [file]);

  // Determine breadcrumb based on where user came from
  const returnTo = location?.state?.returnTo;
  const breadcrumbLabel = returnTo?.label || 'Back to Patient List';
  const breadcrumbPath = returnTo?.path || paths.patients;
  const breadcrumbState = returnTo?.state || null;

  const handleBreadcrumbClick = () => {
    if (returnTo?.path && returnTo?.state) {
      navigate(returnTo.path, { state: returnTo.state });
    } else {
      navigate(breadcrumbPath);
    }
  };
  return (
    <>
      <Seo title="Dashboard: Product Create" />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 8,
        }}
      >
        <Container maxWidth="xl">
          <Stack spacing={3}>
            <Stack spacing={4}>
              <div>
                <Button
                  sx={{
                    justifyContent: 'flex-start',
                    color: '#111927',
                    width: 'max-content',
                    padding: '0px',
                  }}
                  onClick={handleBreadcrumbClick}
                  startIcon={
                    <SvgIcon>
                      <ArrowLeftIcon sx={{ color: '#6C737F' }} />
                    </SvgIcon>
                  }
                >
                  <Typography variant="subtitle1">{breadcrumbLabel}</Typography>
                </Button>
              </div>
              <Stack
                alignItems="center"
                direction="row"
                spacing={2}
              >
                <Box>
                  {action === 'Create' ? (
                    <Avatar
                      sx={{
                        height: 64,
                        width: 64,
                        border: '1px solid black',
                      }}
                    >
                      <label
                        htmlFor="file"
                        style={{
                          width: '100%',
                          display: 'flex',
                          height: '100%',
                          borderRadius: '50%',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        {file && (
                          <img
                            width="100%"
                            height="100%"
                            src={URL.createObjectURL(file)}
                          />
                        )}
                        {!file && 'P'}
                      </label>
                    </Avatar>
                  ) : (
                    <Stack
                      alignItems="center"
                      direction="row"
                      spacing={2}
                    >
                      <Avatar
                        sx={{
                          height: 64,
                          width: 64,
                          border: '1px solid black',
                        }}
                      >
                        <label
                          htmlFor="file"
                          style={{
                            width: '100%',
                            display: 'flex',
                            height: '100%',
                            borderRadius: '50%',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          {file && (
                            <img
                              width="100%"
                              height="100%"
                              src={URL.createObjectURL(file)}
                            />
                          )}
                          {patientData?.profileImage && !file && (
                            <img
                              width="100%"
                              height="100%"
                              src={`data:image/png;base64,${patientData?.profileImage}`}
                              alt=""
                            />
                          )}

                          {!file &&
                            !patientData?.profileImage &&
                            `${getInitials(patientData?.firstName)}${getInitials(
                              patientData?.lastName
                            )}`}
                        </label>
                      </Avatar>
                      <Stack spacing={1}>
                        <Typography variant="h5">
                          {patientData?.lastName ? patientData?.lastName + ' ' : ''}
                          {patientData?.firstName ? patientData?.firstName : ''} - Edit Details
                        </Typography>
                        <Stack
                          alignItems="center"
                          direction="row"
                          spacing={1}
                        >
                          <Chip
                            label={patientData?.active === true ? 'Active' : 'Inactive'}
                            size="small"
                            color={patientData?.active === true ? 'success' : 'warning'}
                            clickable={true}
                          />
                        </Stack>
                      </Stack>
                    </Stack>
                  )}
                </Box>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(event) => setFile(event.target.files && event.target.files[0])}
                  id="file"
                  style={{ display: 'none', position: 'absolute' }}
                />
                <Stack spacing={1}>
                  <Typography variant="h5">{action === 'Create' && 'Add New Patient'}</Typography>
                </Stack>
              </Stack>
            </Stack>
            <CustomerEditForm
              action={action}
              file={base64String}
            />
          </Stack>
        </Container>
      </Box>
    </>
  );
};

export default AddPatientForm;
